import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-down-left', 'ArrowDownLeft', [["path",{"d":"m17.5 6.5-11 11m0-9v9h9","key":"svg-0"}]]);